import React from 'react';
import { NumberBaseConverter } from '../components/number-base-converter/NumberBaseConverter';

export const NumberBaseConverterPage: React.FC = () => {
  return (
    <div className="page-container">
      <NumberBaseConverter />
    </div>
  );
};